import { channelClient, RequestPolicies } from 'shared/channels';
import { createEntityClient, runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { siteContract } from './siteContract';
import type { SiteCreateModel, SiteEditModel, SiteModel } from './types/model';

/**
 * Sites as served by the service worker. Changes resolve once the server
 * accepted them and reject with its error (`ChannelRequestError.messageId`).
 */
export const siteClient = {
  ...createEntityClient(siteContract),

  /** One item for its details view, archived ones included; rejects when there is none. */
  getOneById(id: string): Promise<SiteModel> {
    return channelClient.request(siteContract, 'getOneById', { id }, RequestPolicies.read);
  },

  async create(siteCreateModel: SiteCreateModel): Promise<void> {
    await runQueuedMutation(
      siteContract,
      'create',
      (uniqueId) => ({ siteCreateModel, uniqueId }),
      DomainMessagesTypes.uploadedEntity
    );
  },

  async edit(siteEditModel: SiteEditModel): Promise<void> {
    await runQueuedMutation(
      siteContract,
      'edit',
      (uniqueId) => ({ siteEditModel, uniqueId }),
      DomainMessagesTypes.updatedEntity
    );
  },

  async remove(siteId: string, projectId: string): Promise<void> {
    await runQueuedMutation(
      siteContract,
      'remove',
      (uniqueId) => ({ siteId, projectId, uniqueId }),
      DomainMessagesTypes.deletedEntity
    );
  },

  async restore(siteId: string, projectId: string): Promise<void> {
    await runQueuedMutation(
      siteContract,
      'restore',
      (uniqueId) => ({ siteId, projectId, uniqueId }),
      DomainMessagesTypes.uploadedEntity
    );
  },
};
